<template>
  <div class="space-ba-xxl" id="kontakt">
    <!-- <h2 class="space-ba-xs">Kontakt</h2> -->

    <!-- EINLEITUNG KONTAKT -->
    <div class="space-ba-s" v-html="newLineText(entries.einleitungKontakt)"></div>

    <!-- EMAIL -->
    <div class="link-arrow-wrapper">
      <a :href="`mailto:${entries.email}`" class="type-l link-arrow-a">{{entries.email}}</a>
      <svg class="link-arrow-icon" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-575.000000, -3298.000000)" fill="#20377A" fill-rule="nonzero">
            <polygon points="577.3 3319.404 593.572 3303.168 593.572 3314.4 596.164 3314.4 596.164 3298.632 580.396 3298.632 580.396 3301.224 591.592 3301.224 575.356 3317.496"></polygon>
          </g>
        </g>
      </svg>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Kontakt",
    props: {
      entries: Object
    },
    methods: {
    newLineText(el) {
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
  }
</script>

<style lang="scss" scoped>
.link-arrow-wrapper {
  display: flex;
  align-items: center;
  & a, & svg {
    display: block;
  }
}
</style>